export const ROUTE_LOGIN = '/';
export const ROUTE_HOME = '/home';
export const ROUTE_SELECT_TYPE = '/type';
export const ROUTE_SELECT_OJECTS = '/objects';
export const ROUTE_UPLOAD_FILE = '/file';
export const ROUTE_UPLOAD_STREAM = '/stream';
export const ROUTE_MAPPING = '/mapping';
export const ROUTE_METADATA = '/metadata';
export const ROUTE_FINISHED = '/finished';
